import PropTypes from "prop-types";
import Client from "./Customer";
import Parent from "./Parent";
import { createField, getEntityTypes, getEntityDefaults } from "./utils";

const FamilyPersonalInfo = {
    fileNo: createField(PropTypes.string, ""),
    prefix: createField(PropTypes.string, ""),
    consecutive: createField(PropTypes.number, 0),
    client: createField(PropTypes.shape(getEntityTypes(Client)), getEntityDefaults(Client)),
    type: createField(PropTypes.shape({}), null),
    startDate: createField(PropTypes.instanceOf(Date), null),
    status: createField(PropTypes.shape({}), null),
    notes: createField(PropTypes.string, ""),
    fileLocation: createField(PropTypes.shape({}), null),
    dlNo: createField(PropTypes.string, ""),
    dateOfMarriage: createField(PropTypes.instanceOf(Date), null),
    dateOfSeparation: createField(PropTypes.instanceOf(Date), null),
    children: createField(PropTypes.string, ""),
    jointProperty: createField(PropTypes.string, ""),
    respondent: createField(PropTypes.string, ""),
    respondentAddress: createField(PropTypes.string, ""),
    respondentDob: createField(PropTypes.instanceOf(Date), null),
    respondentSsn: createField(PropTypes.string, ""),
    parent: createField(PropTypes.shape(getEntityTypes(Parent)), getEntityDefaults(Parent)),
    parentId: createField(PropTypes.number, null),
    trnFlowId: createField(PropTypes.number, null),
};

export default FamilyPersonalInfo;

// Set of date-type fields that might be used for calendar event purposes
export const getEventFields = () => [];
